import { render } from "./DefaultUserIcon.vue?vue&type=template&id=7a568114"
const script = {}

import exportComponent from "/builds/skilltech-ph/dash/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__